import { render, staticRenderFns } from "./ModalDocs.vue?vue&type=template&id=561b8376&scoped=true&"
import script from "./ModalDocs.vue?vue&type=script&lang=js&"
export * from "./ModalDocs.vue?vue&type=script&lang=js&"
import style0 from "./ModalDocs.vue?vue&type=style&index=0&id=561b8376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b8376",
  null
  
)

export default component.exports